const projectShareByUrl = () => {
    if (document.querySelector('.ume-projects-holder')) {

        if (window.location.hash) {
            const target = window.location.hash;

            document.addEventListener('showedGrid', (ev) => {
                if (document.querySelector(target)) {
                    const button = document.querySelector(target);

                    button.click();
                }
            }, {once: true})


        }
    }
}
export default projectShareByUrl;